export const SelfServiceConstants = {
  SwitchRunningMode: {
    PollLimit: 10,
    PollInterval: 3000,
  },
};
